<template>
  <FlagPickerField
    :value="value"
    :items="countries"
    :loading="loading"
    :select-placeholder="selectPlaceholder"
    :search-placeholder="searchPlaceholder"
    :search-label="searchLabel"
    :disabled="disabled"
    empty-message="No countries available"
    :format-label="formatCountryLabel"
    @input="$emit('input', $event)"
    @search="$emit('search', $event)"
    @clear="$emit('clear')"
  />
</template>

<script setup>
import FlagPickerField from "@components/FlagPickerField/FlagPickerField.vue";

defineProps({
  value: { type: Object, default: null },
  countries: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  selectPlaceholder: { type: String, default: "Select Country" },
  searchPlaceholder: { type: String, default: "Type to search." },
  searchLabel: { type: String, default: "Search Country" },
  disabled: { type: Boolean, default: false },
});

defineEmits(["input", "search", "clear"]);

function formatCountryLabel(item) {
  return item?.name || "";
}
</script>
